import { Component, OnInit } from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {UserService} from '../../service/user.service';
import {Router} from '@angular/router';
import {DatePipe} from '@angular/common';
import Swal from "sweetalert2";
import {ScrollToConfigOptions, ScrollToService} from '@nicky-lenaers/ngx-scroll-to';
import {OwlOptions} from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-new-review',
  templateUrl: './new-review.component.html',
  styleUrls: ['./new-review.component.css']
})
export class NewReviewComponent implements OnInit {
    currentRate: any;
  reviewForm: any;
  review: any;

  constructor(private scrollToService: ScrollToService,private formBuilder: FormBuilder,private userService:UserService,private route :Router, private datePipe: DatePipe) {
    this.reviewForm = this.formBuilder.group({
      email: ['',Validators.required],
      name: ['', Validators.required],
      review: ['', Validators.required],
    });
  }

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: false,
    pullDrag: false,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: {
        items: 3
      },
      600: {
        items: 3
      },
      900: {
        items: 3
      }
    },
    nav: false
  };

  testiOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: false,
    pullDrag: false,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 2
      },
      900: {
        items: 3
      }
    },
    nav: false
  };
  ngOnInit(): void {
  this.triggerScrollTo();
  this.getAllReviews();
  }

  reveiw(){
    let req ={
      clientEmail:  this.reviewForm.controls.email.value,
      clientName:  this.reviewForm.controls.name.value,
      review:  this.reviewForm.controls.review.value,
    }
    console.log('rate'+ this.currentRate);
    this.userService.addReview(req).subscribe(
        res => {
          if (res.responseCode == 200) {
            Swal.fire(
                'Review Success!',
                'session booked successfully',
                'success'
            )
            this.route.navigate(['/index-travel']);
          } else {
            Swal.fire(
                'Review Faild !',
                'somthing went wrong please try again',
                'error'
            )
          }
        }
    )
  }

  getAllReviews(){
    console.log('req');
    this.userService.getallReviews().subscribe(
        res=>{
          this.review = res.data;
          console.log(res.data);
        }
    )
  }
  triggerScrollTo() {

    const config: ScrollToConfigOptions = {
      target: 'home'
    };

    this.scrollToService.scrollTo(config);
  }

}
